__webpack_require__.p = "/linkedinrsc/system-email-templates/";